module.exports = __webpack_public_path__ + "static/media/shell32_154.f0d1ae3a.ico";